import {
  Checkbox,
  Dropdown,
  Icon,
  PrimaryButton,
  Stack,
  TextField,
  Calendar,
  defaultCalendarStrings,
  ComboBox,
  TooltipHost,
  DatePicker,
  defaultDatePickerStrings,
} from "@fluentui/react";
import React, { useContext, useEffect, useRef, useState } from "react";

import "./Analytics.css";
import { t } from "i18next";
import { USERTYPES } from "../../constants/Constants";
import ClearIcon from "../../components/SVGComponents/ClearIcon";
import Moment from "moment";
import { filter } from "underscore";


const primaryButtonHoverStyles = {
  rootHovered: {
    color: "white",
  },
};

const AnalyticsFilter = (props) => {
  const ref = useRef(null);
  const { onClickOutside } = props;
  const [selectedUserIds, setSelectedUserIds] = useState(props.userIds);
  

  const getConsistentDateFormat = (date) => {
    if (Moment(date).isValid()) {
      return Moment(date).format("DD-MMM-YY");
    } else {
      return "No Date";
    }
  };

  const today = new Date();
  let toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const selectDateFrom = (date) => {
    // var formattedDate = formatDate(date);
    props.setFilterObjInChartComponent({ ...props.filterObjInChartComponent, dateFrom: date });
  };

  const selectDateTo = (date) => {
    // var formattedDate = formatDate(date);
    props.setFilterObjInChartComponent({ ...props.filterObjInChartComponent, dateTo: date });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  if (!props.show) return null;

  const handleClearButtonForModality = () => {
    props.setModalityIds([]);
  };

  const handleClearButtonForUser = () =>{
      // setSelectedUserIds([]);
      props.setUserIds([]);
  }

  const handleClearButtonForReturnedReasons = () =>{
    props.setReturnedReasonIds([]);
  }

  const handleClearButtonForRaiseAlertReasons = () => {
    props.setRaiseAlertReasonIds([]);
  }

  const customStyles = {
    // Note that this is actually the wrapper of the input and caret (doesn't include the label)
    optionText:{   
        textWrap: "wrap",
    },
    label:{
        alignItems:"flex-start"
    },
  };

  return (
    <>
    {/* 3 */}
      <div className="filter-popup-analytics" ref={ref} style={{
            // width: "40%",
            display: "flex",
            flexDirection: "column",
            borderRight: (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") ? "1px solid rgb(88, 88, 88)" : "",
            paddingRight: (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") ? "10px" : ""
            }}
      >
      {(props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") && <div
          style={{
            // width: "40%",
            display: "flex",
            // marginLeft: "20px",
            alignItems:"center",
            paddingTop:"10px"
          }}
        >
          <div style={{ display: "flex"}}>
            <PrimaryButton
              onClick={() => {
                props.setDateByInComponent(1);
              }}
              text={t("analytics.assignment-date")}
              style={{
                fontSize: "12px",
                fontWeight: "400",
                padding: "0px 3px",
                whiteSpace: "nowrap",
                borderTopLeftRadius: "30px",
                borderBottomLeftRadius: "30px",
                zIndex: props.dateByInComponent !== 1 ? "" : "100",
                background: props.dateByInComponent !== 1 ? "black" : "",
                outline: "white",
                borderTopRightRadius: props.dateByInComponent == 1 ? "30px" : "",
                borderBottomRightRadius: props.dateByInComponent == 1 ? "30px" : "",
                paddingRight: props.dateByInComponent !== 1 ? "10px" : "",
              }}
              styles={primaryButtonHoverStyles}
            />
            <PrimaryButton
              onClick={() => {
                props.setDateByInComponent(2);
              }}
              text={t("analytics.study-date")}
              style={{
                fontSize: "12px",
                fontWeight: "400",
                padding: "0px 3px",
                whiteSpace: "nowrap",
                marginLeft: "-12px",
                borderTopRightRadius: "30px",
                borderBottomRightRadius: "30px",
                paddingLeft: props.dateByInComponent !== 2 ? "10px" : "",
                background: props.dateByInComponent !== 2 ? "black" : "",
                zIndex: props.dateByInComponent !== 2 ? "" : "100",
                borderTopLeftRadius: props.dateByInComponent == 2 ? "30px" : "",
                borderBottomLeftRadius: props.dateByInComponent == 2 ? "30px" : "",
              }}
              styles={primaryButtonHoverStyles}
            />
          </div>
          {props.dateList != undefined && (
          <>
            <div className="client-filter-section-analytics align-filter-section" style={{width:"120px"}}>
              <ComboBox
                selectedKey={props.selectedDate}
                // selectedKey={selectedUserIds}
                placeholder="Select Date"
                options={[...props.dateList]}
                calloutProps={{ doNotLayer: true }}
                onChange={(e, option) => {
                  let selected = option?.selected;
                  if (option) {
                    props.setSelectedDate(() =>option.key);
                  }
                }}
              />
            </div>
          </>
          )}
          <DatePicker
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
            style={{ width: "180px", margin:"5px",marginBottom:"0px",padding:"0px" }}
            name="dob"
            value={props.filterObjInChartComponent.dateFrom}
            onSelectDate={selectDateFrom}
            strings={defaultDatePickerStrings}
            placeholder={t("analytics.from")}
            maxDate={today}
            formatDate={getConsistentDateFormat}
            disabled={props.selectedDate == 6 ? false : true}
          />
          <DatePicker
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
            style={{ width: "180px", margin:"5px",marginBottom:"0px",padding:"0px" }}
            name="dob"
            value={props.filterObjInChartComponent.dateTo}
            onSelectDate={selectDateTo}
            strings={defaultDatePickerStrings}
            placeholder={t("analytics.to")}
            maxDate={toDate}
            formatDate={getConsistentDateFormat}
            disabled={props.selectedDate == 6 ? false : true}
          />
        </div>
        }
        <div style={{
            // width: "40%",
            display: "flex",
            // flexDirection:"row"
            flexDirection:"row-reverse",
            paddingBottom:"10px"
          }}>
      {/* 3 */}
      {/* <div className="filter-popup-analytics" ref={ref}> */}
        {props.modalityList != undefined && (
          <>
            <div className="modality-filter-section-analytics align-filter-section" style={{flexDirection:"row"}}>
              <ComboBox
                selectedKey={props.modalityIds}
                placeholder="Select Modality"
                options={[...props.modalityList]}
                multiSelect
                calloutProps={{ doNotLayer: true }}
                label= {(props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count")? "Select Modality" : "" }
                allowFreeInput
                autoComplete="on"
                onChange={(e, option) => {
                  let selected = option?.selected;
                  if((props.chartType != "edit_reports_count" && props.chartType != "returned_studies_count" && props.chartType != "raised_alert_count") && selected && props.modalityIds.length >= 3) {
                    props.setAlertSuccessModal(() => {
                      const newItem = { ...props.alertSuccessModal };
                      newItem.show = true;
                      newItem.heading = "Error";
                      newItem.description = t(
                        "analytics.max-modalities-selected"
                      );
                      return newItem;
                    });
                    return;
                  }

                  if (option) {
                    props.setModalityIds((prevSelectedKeys) =>
                      selected
                        ? [...prevSelectedKeys, option.key]
                        : prevSelectedKeys.filter((k) => k !== option.key)
                    );
                  }
                }}
              />
              {(props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") && <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2" onClick={() => handleClearButtonForModality()} style={{ alignItems:"flex-end",justifyContent:"center",display:"flex"}}>
              <TooltipHost content="Clear">
                <ClearIcon></ClearIcon>
              </TooltipHost>
              </div>}
            </div>
          </>
        )}
        {/* 4 */}
        {props.clientList != undefined && (
          <>
            <div className="client-filter-section-analytics align-filter-section">
              <ComboBox
                selectedKey={props.clientIds}
                placeholder={`${
                  props.role === USERTYPES.ADMIN
                    ? "Select Firm"
                    : "Select Client"
                }`}
                options={[...props.clientList]}
                multiSelect
                calloutProps={{ doNotLayer: true }}
                allowFreeInput
                autoComplete="on"
                onChange={(e, option) => {
                  let selected = option?.selected;
                  if (selected && props.clientIds.length >= 4) {
                    props.setAlertSuccessModal(() => {
                      const newItem = { ...props.alertSuccessModal };
                      newItem.show = true;
                      newItem.heading = "Error";
                      newItem.description = t("analytics.max-clients-selected");
                      return newItem;
                    });
                    return;
                  }
                  if (option) {
                    props.setClientIds((prevSelectedKeys) =>
                      selected
                        ? [...prevSelectedKeys, option.key]
                        : prevSelectedKeys.filter((k) => k !== option.key)
                    );
                  }
                }}
              />
            </div>
          </>
        )}

        {/* 6 */}
        {props.annotationList != undefined && (
          <>
            <div className="pathology-filter-section-analytics align-filter-section">
              <ComboBox
                selectedKey={props.pathologyIds}
                placeholder="Select Findings"
                options={[...props.annotationList]}
                multiSelect
                calloutProps={{ doNotLayer: true }}
                allowFreeInput
                autoComplete="on"
                onChange={(e, option) => {
                  let selected = option?.selected;
                  if (selected && props.pathologyIds.length >= 6) {
                    props.setAlertSuccessModal(() => {
                      const newItem = { ...props.alertSuccessModal };
                      newItem.show = true;
                      newItem.heading = "Error";
                      newItem.description = t(
                        "analytics.max-pathologies-selected"
                      );
                      return newItem;
                    });
                    return;
                  }
                  if (option) {
                    props.setPathologyIds((prevSelectedKeys) =>
                      selected
                        ? [...prevSelectedKeys, option.key]
                        : prevSelectedKeys.filter((k) => k !== option.key)
                    );
                  }
                }}
              />
            </div>
          </>
        )}
        { props.role == USERTYPES.FIRMADMIN && props.chartType == "returned_studies_count" && props.returnedReasonList != undefined && (
          <>
            <div className="modal-scroll client-filter-section-analytics align-filter-section" style={{flexDirection:"row",width:"30%", alignItems:"center"}}>
              <ComboBox
                selectedKey={props.returnedReasonIds}
                // selectedKey={selectedUserIds}
                placeholder="Select Return Reason"
                options={[...props.returnedReasonList]}
                multiSelect
                calloutProps={{ doNotLayer: true }}
                label="Select Return Study Reason"
                comboBoxOptionStyles={customStyles}
                onChange={(e, option) => {
                  let selected = option?.selected;
                  if (option) {
                    props.setReturnedReasonIds((prevSelectedKeys) =>
                      selected
                        ? [...prevSelectedKeys, option.key]
                        : prevSelectedKeys.filter((k) => k !== option.key)
                    );
                  }
                }}
              />
              {props.chartType == "returned_studies_count" && <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2" onClick={() => handleClearButtonForReturnedReasons()} style={{ alignItems:"flex-end",justifyContent:"center",display:"flex"}}>
              <TooltipHost content="Clear">
                <ClearIcon></ClearIcon>
              </TooltipHost>
              </div>}
            </div>
          </>
        )}

        { props.role == USERTYPES.FIRMADMIN && props.chartType == "raised_alert_count" && props.raiseAlertReasonList != undefined && (
          <>
            <div className="client-filter-section-analytics align-filter-section" style={{flexDirection:"row"}}>
              <ComboBox
                selectedKey={props.raiseAlertReasonIds}
                // selectedKey={selectedUserIds}
                placeholder="Select Raise Alert Reason"
                options={[...props.raiseAlertReasonList]}
                multiSelect
                calloutProps={{ doNotLayer: true }}
                label="Select Raise Alert Reason"
                comboBoxOptionStyles={customStyles}
                onChange={(e, option) => {
                  let selected = option?.selected;
                  if (option) {
                    props.setRaiseAlertReasonIds((prevSelectedKeys) =>
                      selected
                        ? [...prevSelectedKeys, option.key]
                        : prevSelectedKeys.filter((k) => k !== option.key)
                    );
                  }
                }}
              />
              {props.chartType == "raised_alert_count" && <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2" onClick={() => handleClearButtonForRaiseAlertReasons()} style={{ alignItems:"flex-end",justifyContent:"center",display:"flex"}}>
              <TooltipHost content="Clear">
                <ClearIcon></ClearIcon>
              </TooltipHost>
              </div>}
            </div>
          </>
        )}
        { props.role == USERTYPES.FIRMADMIN && (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") && props.userList != undefined && (
          <>
            <div className="client-filter-section-analytics align-filter-section" style={{flexDirection:"row"}}>
              <ComboBox
                selectedKey={props.userIds}
                // selectedKey={selectedUserIds}
                placeholder="Select Radiologist"
                options={[...props.userList]}
                multiSelect
                calloutProps={{ doNotLayer: true }}
                comboBoxOptionStyles={customStyles}
                label= {(props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count")? "Select Radiologist" : "" }
                onChange={(e, option) => {
                  let selected = option?.selected;
                  if (option) {
                    props.setUserIds((prevSelectedKeys) =>
                      selected
                        ? [...prevSelectedKeys, option.key]
                        : prevSelectedKeys.filter((k) => k !== option.key)
                    );
                  }
                }}
              />
              {(props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") && <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2" onClick={() => handleClearButtonForUser()} style={{ alignItems:"flex-end",justifyContent:"center",display:"flex"}}>
              <TooltipHost content="Clear">
                <ClearIcon></ClearIcon>
              </TooltipHost>
              </div>}
            </div>
          </>
        )}

        {/* 6 */}
        {props.role != USERTYPES.RADIOLOGIST &&
          (props.providerList != undefined) && (
            <>
              <div className="client-filter-section-analytics align-filter-section">
                <ComboBox
                  selectedKey={props.providerIds}
                  placeholder="Select Provider"
                  options={[...props.providerList]}
                  multiSelect
                  calloutProps={{ doNotLayer: true }}
                  allowFreeInput
                  autoComplete="on"
                  onChange={(e, option) => {
                    let selected = option?.selected;

                    if (selected && props.providerIds.length >= 6) {
                      props.setAlertSuccessModal(() => {
                        const newItem = { ...props.alertSuccessModal };
                        newItem.show = true;
                        newItem.heading = "Error";
                        newItem.description = t(
                          "analytics.max-providers-selected"
                        );
                        return newItem;
                      });
                      return;
                    }
                    if (option) {
                      props.setProviderIds((prevSelectedKeys) =>
                        selected
                          ? [...prevSelectedKeys, option.key]
                          : prevSelectedKeys.filter((k) => k !== option.key)
                      );
                    }
                  }}
                />
              </div>
            </>
          )}
          </div>
      </div>
    </>
  );
};

export default AnalyticsFilter;
